import pako from 'pako';

// Unzips the payload given, returning a JSON object
// used to unzip centrifugo payloads
export const unzipPayload = (payload) => {
  try {
    // Decode base-64 encoded string and decompress
    const resource = JSON.parse(pako.inflate(atob(payload), { to: 'string' }));
    return resource;
  } catch (err) {
    return undefined;
  }
};

export default unzipPayload;
